import CanvasSVGDrawer from './CanvasSVGDrawer';
class LabelLegendSVGDrawer extends CanvasSVGDrawer {

	constructor() {
		super();
		this._labels = [];
	}


	setlabels(val, callback = null) {

		if (val === this._labels) {
			return;
		}
		this._labels = val;
		this._buildRows();
		this.createImage(callback);
	}

	set svgTemplateString(val) {
		super.svgTemplateString = val;
		this._buildRows();
	}

	_buildRows() {
		if(this._labels.length>8){
			this._template.querySelector(`[id="bg"]`).style.width = 82;
			this._template.querySelector(`[id="bg"]`).style.height = 44;
			//this._template.querySelector(`[id="bg_shadow"]`).style.width = 82;
			//this._template.querySelector(`[id="bg_shadow"]`).style.height = 44;
		}else{
			this._template.querySelector(`[id="bg"]`).style.width = 40;
			this._template.querySelector(`[id="bg"]`).style.height = this._labels.length * 5 + 4;
			//this._template.querySelector(`[id="bg_shadow"]`).style.width = 40;
			//this._template.querySelector(`[id="bg_shadow"]`).style.height = this._labels.length * 5 + 4;
		}

		let grades = ['A', 'B', 'C', 'D', 'F'];
		for (var i = 0; i < 15; i++) {
			let labelRow = this._template.querySelector(`[id="labelRow${i + 1}"]`);
			let gradeIndicator = this._template.querySelector(`[id="gradeIndicator${i + 1}"]`);
			let label = labelRow.querySelector('tspan');
			
			if (i < this._labels.length) {

				let { name, highLight } = this._labels[i];
				labelRow.setAttribute('visibility', 'visible');
				label.innerHTML = name;
				if (gradeIndicator) {
					let indicatorBars = gradeIndicator.querySelectorAll('rect');
					for(var j = 0;j<indicatorBars.length;j++){
						if(highLight.indexOf(grades[j]) === -1 ){
							indicatorBars[j].setAttribute('visibility','hidden');	
						}else{
							indicatorBars[j].setAttribute('visibility','visible');	
						}
						
					}
					
				}
			} else {
				if (gradeIndicator) {
					let indicatorBars = gradeIndicator.querySelectorAll('rect');
					for(var j = 0;j<indicatorBars.length;j++){
						
							indicatorBars[j].setAttribute('visibility','hidden');	
						
					}
					gradeIndicator.setAttribute('visibility', 'hidden');
				}
				labelRow.setAttribute('visibility', 'hidden');
			}
		}
	}
}



export default LabelLegendSVGDrawer;